import React, { Component, Fragment } from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import Header from './Common/Header'
import Footer from './Common/Footer'
import Helmet from './Common/Helmet'

const mapStateToProps = (state) => {
    return {
        
    }
}

const mapDispatchToProps = dispatch => ({
    
});

class PageNotFound extends Component {

    constructor(props) {
        super(props);


        this.state = {

        }

    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return <Fragment>
            <Header home={false} />
			<Helmet 
				title={"Page not found"}
				description={"Page description"}
			/>
            
            <section className="gry-log">
                <div className="row">
                    <div className="container">
                        <div className="col l12 m12 s12">
                            <div className="log-head">
                                <h1>Opps!</h1>
                                <p>We could not find the page you are looking for. </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer hyperLink={false}/>

        </Fragment>
    }
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(PageNotFound);